module.exports = __webpack_public_path__ + "img/Platforms.d1955e04.svg";